import { store } from "@/store/LoginDataStore";

const getUrlParam = (name: string) => {
  const results = new RegExp("[?&]" + name + "=([^&#]*)").exec(
    window.location.href
  );
  if (results == null) {
    return "";
  }
  return decodeURI(results[1]);
};

export const useParameterStore = () => {
  const readParametersToStore = () => {
    const customerId = getUrlParam("customerId");
    if (customerId) {
      store.setCustomerId(customerId);
    }

    const username = getUrlParam("username");
    if (username) {
      store.setUsername(username);
    }

    const password = getUrlParam("password");
    if (password) {
      store.setPassword(password);
    }

    if (getUrlParam("error") === "true") {
      store.setErrorMessage(
        "Die Kombination aus Benutzername und Passwort ist nicht korrekt."
      );
    }

    if (getUrlParam("username_error") === "true") {
      store.setErrorMessage(
        "Die Kombination aus Kundennummer und Benutzername ist nicht korrekt."
      );
    }

    if (getUrlParam("infra_error") === "true") {
      store.setErrorMessage(
        "Der Nutzer konnte nicht eindeutig identifiziert werden."
      );

      const clientIdParam = getUrlParam("client_ids");
      if (clientIdParam) {
        store.setClientIds(clientIdParam.split(","));
      }
    }

    const ppErrorMessage = getUrlParam("pp6_error_msg");
    if (ppErrorMessage !== "") {
      store.setErrorMessage(ppErrorMessage);
    }

    if (getUrlParam("logout") === "true") {
      store.setSuccessMessage("Sie wurden erfolgreich ausgeloggt.");
    }
  };

  return {
    readParametersToStore,
  };
};
